// Configuración centralizada de la aplicación
const getKeycloakConfig = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  return {
    url: process.env.REACT_APP_KEYCLOAK_URL || 'https://kong.punchia.online/keycloak/',
    realm: process.env.REACT_APP_KEYCLOAK_REALM || 'punchia',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'punchia',
    
    // URLs de redirección REALES configuradas en Keycloak
    validRedirectUris: {
      localhost: 'http://localhost:3000',
      production: 'https://punchia.online'
    },
    
    // Obtener URL de redirección válida según lo configurado en Keycloak
    getRedirectUri: () => {
      if (isLocalhost) {
        // Redirigir a la raíz, no directamente a dashboard
        return 'http://localhost:3000/';
      }
      return 'https://punchia.online/';
    },
    
    // Configuración para modo desarrollo
    development: {
      useLocalhost: true,
      fallbackUrl: window.location.origin
    }
  };
};

const keycloakConfig = getKeycloakConfig();

const config = {
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_ROOT || 'https://kong.punchia.online',
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
    endpoints: {
      auth: '/auth',
      users: '/users',
      admin: '/admin',
      data: '/data',
      contacts: 'https://kong.punchia.online/contacts/api/feedback',
      combos: '/combos',
      monitor: '/monitor',
      pings: '/pings',
      scores: '/scores',
      subscriptions: '/subscriptions/v1/admin'
    }
  },

  // App Configuration (marca unificada: MyPunch)
  app: {
    name: 'MyPunch',
    version: '2.0.0',
    defaultTitle: 'MyPunch – Mide tu fuerza con IA',
    description: 'MyPunch: app de boxeo con IA para medir la fuerza de tus golpes, entrenar combos guiados y seguir tu progreso desde tu iPhone.',
    contact: {
      email: 'contacto@punchia.online',
      phone: '+34 900 123 456'
    }
  },

  // Configuración de Keycloak actualizada
  keycloak: {
    url: keycloakConfig.url,
    realm: keycloakConfig.realm,
    clientId: keycloakConfig.clientId,
    getRedirectUri: keycloakConfig.getRedirectUri,
    development: keycloakConfig.development
  },

  // Stripe Configuration
  stripe: {
    publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY || ''
  },

  // UI Configuration
  ui: {
    pagination: {
      defaultPageSize: 10,
      pageSizeOptions: [5, 10, 20, 50]
    },
    animation: {
      duration: 300
    }
  },

  // Routes
  routes: {
    public: {
      home: '/',
      features: '/features',
      monitor: '/monitor',
      network: '/red',
      contact: '/contact',
      cookies: '/cookies',
      donations: '/donations',
      privacy: '/privacy',
      login: '/login',
      logout: '/logout'
    },
    protected: {
      dashboard: '/dashboard',
      profile: '/profile'
    },
    admin: {
      base: '/admin',
      dashboard: '/admin',
      combos: '/admin/combos',
      contacts: '/admin/contacts',
      config: '/admin/config',
      data: '/admin/data',
      users: '/admin/users',
      settings: '/admin/settings',
      network: '/admin/network',
      videos: '/admin/videos',
      subscriptions: '/admin/subscriptions',
      analytics: '/admin/analytics',
      backup: '/admin/backup'
    }
  }
};

export default config; 